import React from 'react';

export const stopPropagation = (e: React.MouseEvent<HTMLHeadingElement>) => e.stopPropagation();
